<template>
    <div class="d-flex flex-column align-center">
        <span class="text-22 text-lg-24 weight-600 z-2">Welcome Hunter!</span>
        <span class="text-center text-13 text-lg-14 mt-2 z-2">
            <span class="weight-500 opacity-60">Sign up now and get </span>
            <span class="text-primary mx-1">250</span>
            <span class="weight-500 opacity-60">coin <br /> reward for referring a friend!</span>
        </span>
    </div>
</template>
